// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2phdW","modalFooterButton":"ModalNotes_modalFooterButton__1-1Di"};